module.exports = "https://static.wmbcdn.com/uniweb/images/c0ea0ce2cb79fedb8c9ed6574172fd84.svg";